<template>
    <div class="intro-create">
        <data-form title="Add Intro Paragraph"
                   tag="intro-create"
                   save-button-label="Submit"
                   :field-model="intro"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/intro/list"
                   submit-success-message="intro paragraph created"
                   submit-error-message="Error creating intro paragraph">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import Intro from '@/models/Intro'

export default Vue.extend({
    name: 'IntroCreate',
    data () {
        return {
            intro: Intro,
            fieldGroups: [
                ['route', 'content'],
            ],
        }
    },
    methods: {
        loadModelInstance () {
            return this.$route.query.route ? { route: this.$route.query.route } : {}
        },
        onSubmit (modelInstance) {
            return this.$api.createItem(this, 'intro', modelInstance)
                .then((response) => {
                    if (response.body.id) {
                        this.$router.push(`/intro/view/${response.body.id}`)
                    }
                })
        }
    },
})

</script>
